import React, { useContext } from "react";
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from "react-hot-toast";

import { UserContext } from "./context/UserContext";
import AppRoutes from './routes'
import "./index.css";

function App() {
  const { isAuthenticated } = useContext(UserContext);

  React.useEffect(() => { }, [isAuthenticated]);

  return (
    <>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;
